/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ModalWithButtons from './ModalWithButtons';
import { checkAndRequestFilePermissions } from '../../../utilities/MobileUtil';
import { actions as systemModalActions } from '../../redux/ducks/systemModal';
import { PermissionsRequiredModal, requiredPermissionTypes } from './WarningModal';

function checkPermissionFirst(type, callback, onCancelAction, dispatch) {
  checkAndRequestFilePermissions(
    callback,
    () => {},
    () => {
      dispatch(systemModalActions.push(<PermissionsRequiredModal permissions={[type]} onDismiss={onCancelAction} />));
    },
  );
}
const FilePickerModal = props => {
  const buttons = [
    {
      type: 'secondary',
      action: 'default',
      text: <FormattedMessage id="photoMenu.cancel.button.label" />,
      onClick: props.onCancelAction,
    },
  ];

  if (props.onSelectFileAction) {
    buttons.unshift({
      type: 'primary',
      action: 'default',
      widget: 'file',
      text: <FormattedMessage id="photoMenu.choosePhoto.button.label" />,
      onSelectFile: props.onSelectFileAction,
    });
  }
  if (props.onSelectLibraryAction) {
    buttons.unshift({
      type: 'primary',
      action: 'default',
      text: <FormattedMessage id="photoMenu.choosePhoto.button.label" />,
      onClick: () => {
        checkPermissionFirst(requiredPermissionTypes.library, props.onSelectLibraryAction, props.onCancelAction, props.dispatch)
      },
    });
  }
  if (props.onTakeImageAction) {
    buttons.unshift({
      type: 'primary',
      action: 'default',
      text: <FormattedMessage id="photoMenu.takePhoto.button.label" />,
      onClick: () => {
        checkPermissionFirst(requiredPermissionTypes.image, props.onTakeImageAction, props.onCancelAction, props.dispatch)
      },
    });
  }
  if (props.onDeleteFileAction) {
    buttons.push({
      type: 'primary',
      action: 'destructive',
      text: <FormattedMessage id="photoMenu.deletePhoto.button.label" />,
      onClick: props.onDeleteFileAction,
    });
  }
  return (
    <div className="util-application-frame-forcards-padding util-list-vertical-padding">
      <ModalWithButtons isVisible={props.isVisible} buttons={buttons} options={{ onDismiss: props.onCancelAction }} />
    </div>
  );
};
FilePickerModal.propTypes = {
  isVisible: PropTypes.bool,
  onTakeImageAction: PropTypes.func,
  onSelectLibraryAction: PropTypes.func,
  onSelectFileAction: PropTypes.func,
  onDeleteFileAction: PropTypes.func,
  onCancelAction: PropTypes.func,
  dispatch: PropTypes.func,
};

export default connect()(FilePickerModal);
